module.exports = __webpack_public_path__ + "img/img.da3c12b5.png";